import { RateModelDto } from "../ratemodeldto";
import { DataForEnrolmentCancellationDto } from "./dataForEnrolmentCancellationDto";
import { DataForEnrolmentModificationDto } from "./dataForEnrolmentModificationDto";
import { ListOptionalAdministrativeFeeDto } from "./listOptionalAdministrativeFeeDto";
import { ListProgramOfRegistrationDto } from "./listProgramOfRegistrationDto";
import { ListSelectedDiscountDto } from "./listSelectedDiscountDto";
import { ListSubjectsOfRegistrationDto } from "./listSubjectsOfRegistrationDto";

export class ParamTutitionCalculationDto {

    externalSystemCode!: string;

    idUniqueTransactionExternalSystem!: string;

    idpStudent!: number;

    referenceDate!: string;

    typology!: string;

    rateModelDto: RateModelDto [] = [];

    companyPaymentPercentage!: number;

    companyFixedAmount!: number;

    selectedCofrosStudentPaymentMethodCode!: string;

    numberInstallmentsStudentPaymentMethod!: number;

    firstInstallmentPercentageStudent!: number;

    selectedCofrosCompanyPaymentMethodCode!: string;

    numberInstallmentsCompanyPaymentMethod!: number;

    firstInstallmentPercentageCompany!: number;

    idDiscountPromotionalCode!: number;

    materialShippingIndicator!: string;

    dataForEnrolmentModification: DataForEnrolmentModificationDto = new DataForEnrolmentModificationDto();

    dataForEnrolmentCancelation: DataForEnrolmentCancellationDto = new DataForEnrolmentCancellationDto();

    numberTimesModificationFeeAppliedBefore!: number;

    typeOfRegistration!: string;

    listProgramOfRegistration: ListProgramOfRegistrationDto [] = [];

    listSubjectsOfRegistration: ListSubjectsOfRegistrationDto [] = [];

    listOptionalAdministrativeFee: ListOptionalAdministrativeFeeDto [] = [];

    listSelectedDiscount: ListSelectedDiscountDto [] = [];
    
}